import { useEffect, useState } from "react";

// Add new themes here — CSS block in index.css handles the visuals
export const THEMES = [
  { id: "default",   label: "Default",   swatch: "#27272a" },
  { id: "vaporwave", label: "Vaporwave", swatch: "linear-gradient(to right, #ff00ff, #00ffff)" },
  { id: "cyberpunk", label: "Cyberpunk", swatch: "linear-gradient(to right, #00ff88, #00d4ff)" },
] as const satisfies ReadonlyArray<{ id: string; label: string; swatch: string }>;

export type ThemeId = (typeof THEMES)[number]["id"];

export function useTheme() {
  const [theme, setTheme] = useState<ThemeId>(
    () => (localStorage.getItem("theme") as ThemeId | null) ?? "default"
  );

  useEffect(() => {
    document.documentElement.dataset.theme = theme === "default" ? "" : theme;
    localStorage.setItem("theme", theme);
  }, [theme]);

  return { theme, setTheme };
}
